export const APP_COOKIE_STORAGE_KEYS = {
  /**
   * Уникальный рандомный ключ, по которому backend идентифицирует пользователя и агрегирует запросы
   */
  uniqDeviceID: "mg_udi",
  /**
   * Храним идентификатор сессии для kfp
   */
  ksid: "mg_ksid",
};
